import * as React from "react";

function SvgCircle(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 88 88"
      {...props}
    >
      <path
        d="M43.77 0C19.597 0 0 19.597 0 43.77c0 24.174 19.597 43.77 43.77 43.77 24.174 0 43.77-19.596 43.77-43.77C87.54 19.597 67.945 0 43.77 0z"
        fill="#22CDDB"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgCircle;
